import { strapiInstance } from '@/constants/axios.instances.constants';
import { buildStrapiUrl, loadAbort } from '@/utils';
import { productCatalogListMapper } from '@/mappers';
import type { UseApiCall } from '@/hooks/useStrapiApi';
import type { ProductCatalog, StrapiListRequest, StrapiResponse } from '@/interfaces/strapi';
import type { ProductCatalogModel, StrapiResponseModel } from '@/interfaces/model';

export const getProductBySlug = ({
	pagination,
	filter,
	sort,
	populate,
}: StrapiListRequest): UseApiCall<StrapiResponse<ProductCatalog>> => {
	const controller = loadAbort();

	const url = buildStrapiUrl({
		base: '/productos-catalogos',
		pagination,
		filter: typeof filter === 'object' ? filter : undefined,
		sort,
		populate,
	});

	return {
		call: strapiInstance.get(url, {
			signal: controller.signal,
			transformResponse: [
				(raw: string) => {
					const json = JSON.parse(raw) as StrapiResponseModel<ProductCatalogModel>;
					const mapped = productCatalogListMapper(json);
					const first = mapped.list[0];
					return { data: first } satisfies StrapiResponse<ProductCatalog>;
				},
			],
		}),
		controller,
	};
};
